import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationEmptyStateSuitcase = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationEmptyStateSuitcase"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        fillOpacity={0.01}
        d="M65.24 63.48V15.42H55.21c-.25-6.49-5.59-11.69-12.14-11.69H24.24C21 3.73 17.94 5 15.65 7.3c-2.19 2.19-3.42 5.06-3.54 8.13H2.08v48.05l63.16-.01zm-41-51.63h18.83c2.07 0 3.76 1.57 4 3.57H20.24c.23-2 1.93-3.57 4-3.57"
      />
      <path
        fill="#8A9DA6"
        d="M63.23 23.26v6.37c0 5.42-4.39 9.82-9.81 9.82H13.9c-5.42.01-9.82-4.38-9.82-9.8V17.44h59.15v5.83z"
      />
      <path
        fill="#BCC9D1"
        d="M17.98 36.57a1.84 1.84 0 0 0-3.68 0v5.97a1.84 1.84 0 0 0 3.68 0zM53.02 36.56a1.84 1.84 0 0 0-3.68 0v5.97a1.84 1.84 0 0 0 3.68 0zM53.23 21.42h-4.11V15.9c0-3.33-2.71-6.05-6.05-6.05H24.24c-3.33 0-6.05 2.72-6.05 6.05v5.53h-4.11V15.9c0-5.6 4.55-10.16 10.16-10.16h18.83c5.6 0 10.16 4.55 10.16 10.15z"
      />
      <path
        fill="#5E737D"
        fillRule="evenodd"
        d="M43.07 5.24c2.84 0 5.51 1.11 7.53 3.12s3.13 4.69 3.13 7.53v1.03h10l.01 45.06-60.15.01-.01-45.06h10.01v-1.02c0-2.85 1.11-5.53 3.12-7.54s4.69-3.13 7.53-3.13zm19.663 28.807c-1.644 3.45-5.15 5.85-9.213 5.893v2.59c0 1.29-1.05 2.34-2.34 2.34-.62 0-1.21-.24-1.65-.68-.45-.45-.69-1.04-.69-1.66v-2.58H18.48v2.58c.01.63-.24 1.21-.68 1.66s-1.03.69-1.65.69c-1.29 0-2.34-1.05-2.34-2.34v-2.59c-2.72-.02-5.27-1.09-7.2-3.01a10.4 10.4 0 0 1-2.027-2.872L4.59 60.99l58.15-.01zM16.14 35.23c-.74 0-1.34.6-1.34 1.34v5.969c0 .74.6 1.34 1.34 1.34.36 0 .7-.14.95-.39s.39-.59.39-.95v-5.97c0-.36-.13-.7-.39-.95s-.59-.39-.95-.39m35.04-.011c-.36 0-.7.13-.95.39s-.39.59-.39.95v5.97c0 .36.14.7.39.95.26.25.59.39.95.39.74 0 1.34-.6 1.34-1.34v-5.97c0-.74-.6-1.34-1.34-1.34M4.582 29.775A9.25 9.25 0 0 0 7.31 36.24a9.26 9.26 0 0 0 6.49 2.72v-2.38a2.343 2.343 0 0 1 3.99-1.66c.45.44.69 1.03.69 1.65v2.39h30.36v-2.39c0-.62.25-1.21.69-1.65a2.3 2.3 0 0 1 1.65-.69c1.29 0 2.34 1.05 2.34 2.34v2.38l-.01.02c5.09-.05 9.21-4.21 9.21-9.31V17.95h-9v3.99h-5.11v-3.99H18.69v3.99h-5.11v-3.99h-9zM24.24 6.24c-2.58 0-5 1-6.83 2.83l-.01.01a9.58 9.58 0 0 0-2.83 6.83v5.03h3.11v-5.03a6.56 6.56 0 0 1 6.55-6.55h18.83c3.61 0 6.55 2.93 6.55 6.54v5.03h3.11V15.9c0-2.58-1-5-2.83-6.83a9.56 9.56 0 0 0-6.82-2.83zm0 4.11c-3.06 0-5.55 2.49-5.55 5.55l.01-.01v1.03h29.92v-1.03c0-3.05-2.49-5.54-5.55-5.54z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default IllustrationEmptyStateSuitcase;
